import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AOS from "aos";
import "aos/dist/aos.css";
import GrabButton from "../../../Button/GrabButton";
const useStyles = makeStyles((theme) => ({
  bg: {
    color: "white",
    marginTop: "10rem",
    padding: "5rem",
  },
}));

export default function Drink() {
  const classes = useStyles();
  const theme = useTheme();
  useEffect(() => {
    AOS.init({});
  }, []);
  return (
    <Grid container className={classes.bg}>
      <Typography
        variant="h3"
        gutterBottom
        style={{ fontWeight: 300 }}
        data-aos="fade-right"
        data-aos-duration="1000"
      >
        Đồ uống
      </Typography>
      <div data-aos="fade-left" data-aos-duration="2000">
        <Grid item>
          <Typography variant="body1" paragraph>
            Sài Gòn đôi khi mang cái nắng nóng khiến những buổi tập gym của
            chúng ta trở nên mệt mỏi. Do đó, dưới sự sắp xếp của Bếp trưởng từng
            đoạt giải thưởng, O Như đã chọn món Chanh xả mật ong để xây dựng
            bước đi đầu tiên cho một bữa ăn sáng chất lượng và ngon miệng.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph>
            Ông cha ta khẳng định Sả, Chanh và Mật ong đều là những nguyên liệu
            tự nhiên, thân thiện với sức khỏe người dùng. Hơn nữa, kiên trì sử
            dụng nước sả, chanh, mật ong giúp cơ thể tăng cường sức đề kháng ,
            ngăn ngừa vi khuẩn xâm nhập, đồng thời đẩy lùi một số tế bào bệnh
            nguy hiểm cho sức khỏe.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph>
            Người xưa từ lâu ví Sả như một dược liệu quý có công dụng giảm huyết
            áp hiệu quả. Mật ong, một dược liệu quý thứ hai, chứa những thành
            phần dưỡng chất tốt cho sức khỏe. Vì vậy, 2 dược liệu quý kết hợp sẽ
            hỗ trợ người bệnh cao huyết áp kiểm soát tốt chỉ số sức khỏe, chống
            tăng lượng cholesterol, giảm nguy cơ mắc những bệnh tim mạch. Do đó,
            O Như chọn nước sả cây và chanh giúp bạn bắt đầu một ngày mới với
            nhiều dưỡng chất cần thiết!
          </Typography>
        </Grid>
        <Grid
          item
          direction="row"
          style={{
            paddingTop: theme.spacing(5),
            display: "flex",
            alignItems: "center",
          }}
        >
          <GrabButton />
          <Typography
            variant="h6"
            style={{
              padding: theme.spacing(2),
              fontWeight: "bold",
            }}
          >
            HOẶC
          </Typography>
          <Typography variant="h5">
            <a
              href="https://www.google.com/maps/place/B%C3%BAn+B%E1%BA%AFp+B%C3%B2+O+Nh%C6%B0/@10.7400125,106.6757078,17z/data=!4m13!1m7!3m6!1s0x31752faceb2a9621:0x54ec2b6171781878!2zMTM0IMSQxrDhu51uZyBDYW8gTOG7lywgUGjGsOG7nW5nIDQsIFF14bqtbiA4LCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmg!3b1!8m2!3d10.7400125!4d106.6778965!3m4!1s0x31752fcbf2b71fef:0xff4b8413fe51f530!8m2!3d10.7400125!4d106.6778965"
              target="_blank"
              rel="noreferrer"
              style={{ color: "white", textTransform: "uppercase" }}
            >
              Ăn tại quán!
            </a>
          </Typography>
        </Grid>
      </div>
    </Grid>
  );
}
